module.exports = __webpack_public_path__ + "img/Veranza-11-min.60cde323.jpg";